const getTextDate = (relative) => {
  let d = new Date();
  d.setDate(d.getDate() + relative);
  let month = d.getMonth()+1;
  let day = d.getDate();
  return d.getFullYear()+'-'+(month < 10 ? ('0'+month) : month) +'-'+ (day < 10 ? ('0'+day) : day);
}

export default getTextDate